import { Row, Col, Typography, Divider } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Spinner } from '../../components/Spinner';
import { AuthorSalesFields, TABLEAU_AUTHOR_SALES_URL } from '../../core/constants/global-constants';
import ArrowUpperRight from '../../assets/icons/arrow-up-right.svg';

const { Title, Link } = Typography;

const OverlayAuthorSalesSection = ({
  authorName,
  isAuthorSalesLoading,
  authorSalesData,
  customColumn
}) => {
  if (!authorName || !authorSalesData) {
    return null;
  }
  return (
    <>
      <Divider style={{ margin: '14px 0' }} />
      <Title level={5} style={{ margin: '16px 0 8px 0' }}>
        More details about {authorName}
      </Title>
      {isAuthorSalesLoading ? (
        <div style={{ margin: '10px 0', textAlign: 'center' }}>
          <Spinner
            size='default'
            spinning={isAuthorSalesLoading}
            indicator={<LoadingOutlined />}
          />
        </div>
      ) : (
        <div className='overlay-table'>
          {AuthorSalesFields.map((key, index) => (
            <Row
              className={index % 2 === 0 ? 'overlay-odd-row' : 'overlay-even-row'}
              key={key}
            >
              <Col span={12} className='overlay-column'>
                {key}
              </Col>
              <Col span={12} className='overlay-column'>
                {customColumn(key)}
              </Col>
            </Row>
          ))}
          <Row>
            <Col
              span={24}
              className='author-sales-col'
            >
              <Link
                href={TABLEAU_AUTHOR_SALES_URL}
                target='_blank'
                rel='noopener noreferrer'
                className='author-sales-link'
              >
                See more author details on Tableau <img
                  src={ArrowUpperRight}
                  alt='Open in new tab'
                  style={{ width: 16, height: 16, marginLeft: 4 }}
                />
              </Link>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};

export default OverlayAuthorSalesSection;